
      <ng-container id="internal-pages" *ngIf="authService.isLoggedIn$ | async; else externalPages">
        <div style="height: 100vh">
          
          <app-navigation></app-navigation>
          
          <main class="mx-lg-5" [ngStyle]="{'padding-left':settingsService.sidenavExpanded ? '240px' : '48px' }" >                       
             
            <div class="mt-3">             
              <router-outlet></router-outlet>          
            </div>
          </main>

          <app-footer></app-footer>          
        </div>
      </ng-container>

      <ng-template #externalPages>
        <router-outlet></router-outlet> 
      </ng-template>